import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React, { CSSProperties } from 'react';

import colors from '../../themes/main-colors';
import Link from '../text-link';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    // '&:focus': {
    // backgroundColor: theme.palette.primary.main,
    // '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    // color: theme.palette.common.white,
    // },
    // },
  },
}))(MenuItem);

// eslint-disable-next-line no-redeclare
export type MenuItem<V = undefined> = {
  icon?: JSX.Element;
  text: string;
  onClick?: (value: V, event: React.MouseEvent) => any;
  link?: string;
  disabled?: boolean;
  style?: CSSProperties;
};

interface CustomMenuProps<V> {
  className?: string;
  items: Array<MenuItem<V>>;
  value?: V; // item value
  moreVertIconColor?: string;
}

export default function<V = undefined>(props: CustomMenuProps<V>) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} className={props.className}>
        <MoreVertIcon htmlColor={props.moreVertIconColor} />
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.items.map(({ disabled, icon, text, link, onClick, style }) => (
          <StyledMenuItem
            disabled={disabled}
            key={text}
            style={style}
            onClick={
              !onClick
                ? undefined
                : e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClick(props.value!, e);
                    handleClose();
                  }
            }
          >
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            {link && <Link plain>{text}</Link>}
            {!link && (
              <Typography style={{ color: colors.sparkBlue }}>
                {text}
              </Typography>
            )}
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
